import React from 'preact';
import { useEffect } from "preact/compat";
import { useState } from "preact/hooks";
import constants from '../../constants';

interface ThreeColumnsProps {
  active: boolean;
}

export default function ThreeColumns({ active }: ThreeColumnsProps) {
  const [primaryColor, setPrimaryColor] = useState('');
  const [secondaryColor, setSecondaryColor] = useState('');

  useEffect(() => {
    if (active) {
      setPrimaryColor(constants.PRICE_COLOR_PRIMARY_ACTIVE);
      setSecondaryColor(constants.PRICE_COLOR_PRIMARY_ACTIVE);
    } else {
      setPrimaryColor(constants.PRICE_COLOR_PRIMARY_INACTIVE);
      setSecondaryColor(constants.COLUMN_COLOR_SECONDARY_INACTIVE);
    }
  }, [active]);

  return (
    <svg viewBox="0 0 46 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path fill={primaryColor} d="M12.498.07H.261C.115.07 0 .21 0 .387v2.206c0 .175.115.316.261.316h12.237c.146 0 .261-.14.261-.316V.387c0-.176-.115-.317-.261-.317zM12.498 16.795H.261c-.146 0-.261.14-.261.316v2.215c0 .176.115.316.261.316h12.237c.146 0 .261-.14.261-.316V17.11c0-.176-.115-.316-.261-.316zM12.498 25.161H.261c-.146 0-.261.14-.261.317v2.214c0 .176.115.317.261.317h12.237c.146 0 .261-.14.261-.317v-2.214c0-.176-.115-.317-.261-.317zM12.498 8.437H.261c-.146 0-.261.14-.261.308v2.205c0 .176.115.317.261.317h12.237c.146 0 .261-.14.261-.317V8.745c0-.176-.115-.317-.261-.317v.009z"/>
            <path fill={secondaryColor} d="M29.124.07H16.887c-.146 0-.261.14-.261.317v2.206c0 .175.115.316.26.316h12.238c.146 0 .26-.14.26-.316V.387c0-.176-.114-.317-.26-.317zM29.124 16.795H16.887c-.146 0-.261.14-.261.316v2.215c0 .176.115.316.26.316h12.238c.146 0 .26-.14.26-.316V17.11c0-.176-.114-.316-.26-.316zM29.124 25.161H16.887c-.146 0-.261.14-.261.317v2.214c0 .176.115.317.26.317h12.238c.146 0 .26-.14.26-.317v-2.214c0-.176-.114-.317-.26-.317zM29.124 8.437H16.887c-.146 0-.261.14-.261.316v2.206c0 .176.115.317.26.317h12.238c.146 0 .26-.141.26-.317V8.753c0-.175-.114-.316-.26-.316z"/>
            <path fill={primaryColor} d="M45.739 0H33.502c-.146 0-.261.14-.261.316v2.206c0 .176.115.317.261.317h12.237c.146 0 .261-.141.261-.317V.316C46 .141 45.885 0 45.739 0zM45.739 16.724H33.502c-.146 0-.261.141-.261.317v2.215c0 .175.115.316.261.316h12.237c.146 0 .261-.14.261-.316V17.04c0-.176-.115-.317-.261-.317zM45.739 8.367H33.502c-.146 0-.261.14-.261.316v2.206c0 .176.115.316.261.316h12.237c.146 0 .261-.14.261-.316V8.683c0-.176-.115-.316-.261-.316z"/>
        </g>
    </svg>
  );
}